<div mat-dialog-title>
  <span>
    {{ 'TEAMS.INVITE_USERS_TO' | translate }}
    {{ spaceName + ('MAP.COMPANY_HEADER' | translate | lowercase) }}
  </span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message class="error-message" *ngIf="error" type="error">
  {{ error | translate }}
</q9-info-message>

<mat-dialog-content class="dialog-content">
  <form #form="ngForm" [formGroup]="inviteUserForm">
    <div class="content">
      <div class="select-container">
        <q9-suggestion-chip-grid
          formControlName="emails"
          [displayFn]="displayEmail"
          [validateFn]="validateEmail"
          [convertFn]="convertEmail"
          [placeholder]="'TEAMS.INVITE_USER_EMAIL_LABEL' | translate"
          [maxChips]="10"
          [maxChipsHintText]="'CORE.MAP.MAX_INVITE_HINT' | translate: {max: 10}">
          <span q9-mat-error>{{ emailsErrorKey | translate }}</span>
        </q9-suggestion-chip-grid>

        <q9-select
          formControlName="role"
          [panelClass]="'role-list'"
          [isAutoPanelWidth]="false"
          (selectionChange)="onRoleChange($event)">
          <q9-option
            [value]="USER_ROLES.VIEWER"
            [subtext]="'USER.ROLE_VIEWER_DESCRIPTION' | translate">
            {{ 'USER.ROLE_VIEWER' | translate }}
          </q9-option>
          <q9-option
            [value]="USER_ROLES.EDITOR"
            [disabled]="!isAdmin"
            [tooltip]="!isAdmin ? 'TEAMS.NEED_PERMISSIONS_MANAGE' : ''"
            [subtext]="'USER.ROLE_EDITOR_DESCRIPTION' | translate">
            {{ 'USER.ROLE_EDITOR' | translate }}
          </q9-option>
          <q9-option
            [value]="USER_ROLES.MANAGER"
            [disabled]="!isAdmin"
            [tooltip]="!isAdmin ? 'TEAMS.NEED_PERMISSIONS_ADMIN' : ''"
            [subtext]="'USER.ROLE_SPACE_ADMIN_DESCRIPTION' | translate">
            {{ 'USER.ROLE_SPACE_ADMIN' | translate }}
          </q9-option>
        </q9-select>
      </div>

      <div class="edit-rights" formGroupName="grantedEditRights">
        <p class="permissions-label">{{ 'USER.GRANT_EDIT_RIGHTS' | translate }}</p>
        <div class="edit-rights-group">
          <mat-slide-toggle formControlName="editorOnAllMaps">
            {{ 'USER.EDITOR_ON_MAPS' | translate }}
          </mat-slide-toggle>

          <mat-slide-toggle formControlName="editorOnAllSFOrgs">
            {{ 'USER.EDITOR_ON_SF_ORGS' | translate }}
          </mat-slide-toggle>

          <mat-slide-toggle formControlName="editorOnAllRefModels">
            {{ 'USER.EDITOR_ON_REF_MODELS' | translate }}
          </mat-slide-toggle>
        </div>
      </div>

      <q9-text-field
        class="invite-message"
        label="TEAMS.INVITE_MESSAGE_LABEL"
        formControlName="message"></q9-text-field>
    </div>
  </form>

  <ng-template #proFeature>
    <small class="checkbox-sublabel" *ngIf="!isProSpace || isProTrialExpired">
      <ng-container *ngIf="!isProSpace && !isProTrialExpired">
        {{ 'TEAMS.PAID_FEATURE_LABEL' | translate }}
      </ng-container>
      <ng-container *ngIf="isProTrialExpired && !proPlus()">
        {{ 'TEAMS.PRO_TRIAL_EXPIRED_LABEL' | translate }}
      </ng-container>
      <ng-container *ngIf="isProTrialExpired && proPlus()">
        {{ 'TEAMS.ENT_TRIAL_EXPIRED_LABEL' | translate }}
      </ng-container>
    </small>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'GENERAL.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="isSubmitted" (click)="form.onSubmit($event); onSubmit()">
    {{ 'MAP.INVITE_MODAL_BTN_INVITE' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
